/**
 * Table Schema Registry — auto-resolves `schemaRef` strings to `ExternalTableSchema` objects.
 *
 * Table schemas are registered once at app startup (side-effect imports).
 * The form engine's `FormEmbeddedTableRenderer` looks up schemas by ref string —
 * no prop drilling through `meta` needed.
 *
 * @example
 * // In app bootstrap or schema file:
 * import { TableSchemaRegistry } from '@packages/form-engine';
 * import { convertiblesTable } from '@apps/customer/pages/convertibles/schema';
 * TableSchemaRegistry.register('convertibles', convertiblesTable);
 *
 * // In domain.json:
 * "relatedConvertibles": { "type": "embedded-table", "schemaRef": "convertibles" }
 */

const registry = new Map<string, unknown>();

export const TableSchemaRegistry = {
  register(schemaRef: string, schema: unknown): void {
    registry.set(schemaRef, schema);
  },

  get(schemaRef: string): unknown | undefined {
    return registry.get(schemaRef);
  },

  has(schemaRef: string): boolean {
    return registry.has(schemaRef);
  },

  getAll(): ReadonlyMap<string, unknown> {
    return registry;
  },
} as const;
